import _ from 'lodash';
import { Editor } from 'slate';

import { hasInlineParent } from '../helpers';
import linkifyIt from 'components/lib/linkify_it';
import { PHRASE_SUGGESTION } from 'components/text_editor/plugins/phrase_suggestions';

export default function normalize(editorValue) {
  // Use a raw slate Editor controller to allow us to modify `editorValue` without a ref to a Slate Editor.
  const editor = new Editor({
    plugins: [],
    onChange: _.noop,
    value: editorValue,
  });

  let textNodeIndex = 0;
  while (textNodeIndex < editor.value.document.getTexts().count()) {
    // Since we may be inserting additional text nodes as we go, we need to treat editor as if it is being mutated from
    // underneath us, so we need to grab each text by index fresh from the editor each iteration.
    let textNode = editor.value.document.getTexts().get(textNodeIndex);
    if (hasInlineParent(editor, textNode)) {
      textNodeIndex++;
      continue;
    }

    let text = textNode.text;
    let matches = linkifyIt.match(text);

    // Linkify returns multiple matches for each text, but because we are going to be inserting a new text node each time
    // we insert the link inline, the indexes for the other matches will become out of sync. Easier to just let the next
    // loop interation deal with it.
    if (matches) {
      let match = matches[0];
      editor
        .moveToRangeOfNode(textNode)
        .moveStartTo(textNode.key, match.index)
        .moveEndTo(textNode.key, match.lastIndex)
        .wrapInline({
          type: 'link',
          data: {
            href: match.url,
          },
        });
    }

    textNodeIndex++;
  }

  const firstTextNode = editor.value.document.getTexts().get(0);
  if (!firstTextNode.text) {
    // For some reason, Slate doesn't like it when I remove the first text node, and will "normalize" the editor
    // after I remove the node. Can't use `editor.withoutNormalizing()`, since that also calls normalizeDirtyPaths
    // for some reason.
    // It's not that big of a deal since we're ditching this editor immediately afterwards.
    editor.tmp.normalize = false;
    editor.removeNodeByKey(firstTextNode.key);
  }

  // If they submit with a phrase suggestion still present, remove it
  const phraseSuggestionInlines = editor.value.document.getInlinesByType(PHRASE_SUGGESTION);
  if (phraseSuggestionInlines.count()) {
    editor.withoutSaving(() => {
      phraseSuggestionInlines.forEach(phraseSuggestionInline => {
        editor.removeNodeByKey(phraseSuggestionInline.key);
      });
    });
  }

  return editor.value;
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/normalizers/rich_text.jsx